<template>
  <v-container v-if="system_setting">
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-card-text>
        <validation-observer v-slot="{ invalid }">
          <v-form>
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="max:65535"
                      name="詳細"
                    >
                      <div>
                        <vue-editor :editor-toolbar="customToolbar"
                          v-model="system_setting[terms.content]"
                          :error-messages="errors"
                          corsProxy="true"
                          class="custom-quill-container"
                        />
                      </div>
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  :disabled="invalid"
                  @click="registerButtonClickEvent"
                >
                  保存
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Confirm from '../../../components/Confirm'
export default {
  name: 'MyPageForm',
  components: {
    Confirm
  },
  mixins: [],
  props: {
  },
  data () {
    return {
      // customToolbar: [
      //   ["bold", "italic", "underline"],
      //   [{ list: "ordered" }, { list: "bullet" }],
      //   ["image", "code-block"]
      // ],
      customToolbar:[
        // [{ 'font': [] }],
        [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
        // [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        [{ 'header': 1 }, { 'header': 2 }],
        ['blockquote', 'code-block'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
        // ['link', 'image', 'video', 'formula'],
        // [{ 'direction': 'rtl' }],
        ['clean'],
      ],
      system_setting: null
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    terms() {
      const map = { 
        emission: {
          title: '排出利用規約', 
          content: 'terms_of_emission'
        }, 
        edi_request: {
          title: 'EDI申請利用規約', 
          content: 'terms_of_edi_request'
        }
      }
      return map[this.type]
    },
    breadcrumbs() {
      return [
        {
          text: this.terms.title, 
          disabled: false, 
          to: { name: 'AdminSystemShow' },
          exact: true
        },
        {
          text: this.terms.title + '編集',
          disabled: true,
          to: ''
        }
      ]
    } 
  },
  created() {
    this.showSystemSetting().then((content) => {
      this.system_setting = content
    })
  },
  methods: {
    ...mapActions('AdminSystemSetting', {
      showSystemSetting: 'show',
      updateSystemSetting: 'update'
    }),
    
    /**
     * キャンセルボタンクリック イベント
     */
    cancelButtonClickEvent () {
      // this.goToIndex()
    },
    /**
     * 保存ボタンクリック イベント
     */
    registerButtonClickEvent () {
      const content = this.terms.content
      const params = {
        [content]: this.system_setting[content]
      }
      this.updateSystemSetting({params: params}).then(() => {
        this.goToIndex()
      })
    },
    goToIndex() {
      this.$router.push({name: 'AdminSystemShow', params: { type: this.type }})
    }
  },
}

</script>

<style scoped lang="scss">
.custom-quill-container {
  /deep/ {
    #quill-container {
      height: 40vw;
    }
  }
}
</style>
